// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__IYd7y","tooltipArrow":"tooltip_tooltipArrow__RtJPV"};